import { Link } from "react-router";
import { Seo } from "../components/Seo";

export function NotFound() {
  return (
    <div className="bg-stone-50 py-24 text-gray-950">
      <Seo
        title="Seite nicht gefunden"
        description="Die angeforderte Seite wurde nicht gefunden."
        noIndex
      />

      <section className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <p className="text-sm font-medium uppercase tracking-[0.2em] text-gray-500">404</p>
        <h1 className="mt-4 text-4xl leading-tight lg:text-5xl">Seite nicht gefunden</h1>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-gray-700">
          Die URL existiert nicht oder wurde verschoben.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center border border-black px-6 py-3 text-sm font-medium text-black transition-colors hover:bg-black hover:text-white"
        >
          Zur Startseite
        </Link>
      </section>
    </div>
  );
}
